import {
  ApplicationUserPaymentFeeWithUSDT,
  GetApplicationUserEdit,
  GetUser,
} from "./api";

import http from "config/http";

const userApi = {
  getApplicationUserEdit: async () => await http.get(GetApplicationUserEdit),

  getUser: async () => await http.get(GetUser),

  applicationUserPaymentFeeWithUSDT: async (body) =>
    await http.post(ApplicationUserPaymentFeeWithUSDT, body, {
      headers: {
        "content-type": "multipart/form-data",
      },
    }),
};

export default userApi;
